import { render, staticRenderFns } from "./OffBoardings.vue?vue&type=template&id=52e80116&"
import script from "./OffBoardings.vue?vue&type=script&lang=js&"
export * from "./OffBoardings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports